<template>
  <div class="rank-bg">
    <div class="l-rank-wrapper">
      <div class="l-rank-contanier">
        <div class="l-rank-title-left">
          <div class="l-back" @click="onGoBack"></div>
        </div>
        <div class="l-rank-title-middle"></div>
        <img class="l-rank-title-middle-name" :src="$route.query.sort === RANK_TYPE.FINISH
          ? require('./images/l-rank-ranking.png')
          : require('./images/l-rank-ranking.png')
        " alt />
        <div class="l-rank-title-right"></div>
        <div class="l-rank-content">
          <div class="l-rank-inner">
            <div class="l-rank-static">
              <table class="l-rank-static-table">
                <tr>
                  <!-- 我的成绩 -->
                  <td class="l-rank-grade">
                    <span class="l-my-grade-img">
                      <img :src="rankInfo?.user?.avatar != '' ? rankInfo?.user?.avatar : avatar
                      " class="l-my-headImg" :onerror="defaultImg" alt />
                    </span>
                    <span class="l-my-grade-box">
                      <span class="l-my-grade-name">
                        {{ rankInfo?.user?.name }}
                        <br />
                        <template v-if="$route.query.sort === RANK_TYPE.RANKING">
                          排名:{{
                            rankInfo.no === 999 ? '未上榜' : '第' + (rankInfo.no) + '名'
                          }}
                        </template>
                      </span>
                    </span>
                  </td>
                  <td v-if="$route.query.sort === RANK_TYPE.RANKING">
                    <span class="l-my-grade-span span-font">战绩</span>
                  </td>
                  <!-- 完成时间 -->
                  <td class="l-my-grade-span span-font">
                    完成时间
                    <br />
                    {{ timestampToTime(rankInfo.time) }}
                  </td>
                  <!-- 提醒我的人 排行榜不需要 -->
                  <td class="td-remind-onLike l-my-grade-span span-font">
                    <span class="l-up-span">
                      <span class="l-zan-tip-word">{{ rankInfo?.likes?.length }}人赞了我</span>
                      <span class="l-zan-tip-word" v-if="$route.query.sort === RANK_TYPE.FINISH">,{{
                        rankInfo?.reminds?.length
                      }}人提醒了我</span>
                    </span>
                  </td>
                </tr>
              </table>
            </div>
            <section class="l-table-list">
              <table>
                <tr v-for="(item, index) in rankList" :key="index">
                  <td class="l-table-img" :class="{ lTableImgComplete: $route.query.sort === RANK_TYPE.FINISH }">
                    <!-- 排行榜 -->
                    <template v-if="$route.query.sort === RANK_TYPE.RANKING">
                      <span v-if="item.no <= 3">
                        <!-- 排名 1-2-3名为奖杯-->
                        <img class="l-cup-img" :src="require('./images/l-rank-num-' +
                          (item.no) +
                          '.png')
                        " alt="奖杯" />
                      </span>
                      <!-- 4以后 排行榜为数字 -->
                      <span class="l-rank-num4" v-else>{{ item.no }}</span>
                    </template>

                    <!-- 完成榜 统一展示“--” -->
                    <span v-if="$route.query.sort === RANK_TYPE.FINISH">
                      <span class="l-rank-num4"></span>
                    </span>
                    <!-- 人物头像 -->
                    <img class="l-headImg" :src="item.user.avatar != '' ? item.user.avatar : avatar" :onerror="defaultImg"
                      alt />
                    <span class="l-headName">{{ item.user.name }}</span>
                  </td>
                  <!-- 排行榜 显示战绩 -->
                  <td class="span-font" v-if="$route.query.sort === RANK_TYPE.RANKING">
                    <span class="l-rank-span-r l-span-star">
                      <img class="l-star-bg" :class="{ 'l-star-bg-active': i <= item.star }" :src="i <= item.star
                        ? require('./images/l-rank-stars.png')
                        : require('./images/l-rank-stars-gray.png')
                      " v-for="(i, index) in 5" :key="index" />
                    </span>
                  </td>
                  <td class="span-font">{{ timestampToTime(item.time) }}</td>
                  <!-- 排行榜下只需要点赞操作，完成榜下，未学完展示为提醒，学习完成展示为点赞 -->
                  <td>
                    <!-- 点赞 -->
                    <span class="span-font">
                      <!-- 已点赞 不可撤销 -->
                      <img title="已点赞" src="./images/l-rank-star.png" class="l-table-icon l-thumb-up-img"
                        @click="onLike(item)" />
                      {{ item.likes.length }}
                    </span>
                    <span v-if="$route.query.sort === RANK_TYPE.FINISH">
                      <span class="span-font">
                        <img @click="onPush(item)" title="提醒" src="./images/l-rank-tip.png"
                          class="l-table-icon l-remind-img" />
                        {{ item.reminds.length }}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Study2Model from '@/models/study2'
const study2 = new Study2Model()
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('user')

export default {
  data () {
    return {
      RANK_TYPE: {
        RANKING: 'STAR', // 排行榜
        FINISH: 'TIME', // 完成榜
      },
      rankList: [],
      rankInfo: '', //排行榜基本信息
      avatar: require('../../assets/images/l-avatar.png'),
      defaultImg: 'this.src="' + require('@/assets/images/l-avatar.png') + '"',
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted () {
    this._rank()
  },
  methods: {
    _rank () {
      study2
        .rank({
          id: this.$route.query.id,
          lessonId: this.$route.query.lessonId,
          sort: this.$route.query.sort,
        })
        .then((res) => {
          this.rankInfo = res.data ? res.data[0] : {}
          this.rankList = res.data || []
          this.rankList ? this.rankList.splice(0, 1) : null
        })
    },
    //点赞
    onLike (data) {
      this._rankOpr('LIKE', data.recordId)
    },
    //提醒
    onPush (data) {
      this._rankOpr('REMIND', data.recordId)
    },
    timestampToTime (time) {
      if (!time) {
        return '--'
      }
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var date = new Date(time)
      // let y = date.getFullYear();
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return MM + '/' + d + ' ' + h + ':' + m
    },
    //返回
    onGoBack () {
      this.$router.go(-1)
    },
    _rankOpr (cmd, recordId) {
      study2
        .rankOpr({
          id: recordId,
          lessonId: this.$route.query.lessonId,
          cmd: cmd,
        })
        .then(() => {
          this._rank()
        })
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './style/rank.styl'
</style>
